var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLink)?_c('div',[_c('a',{attrs:{"href":_vm.linkEndpoint,"target":"_blank"}},[_c('v-icon',[_vm._v(" mdi-link ")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }